import { IAdpVoucherHolder } from '@nkr/models/adp-voucher-holder';
import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    list: IAdpVoucherHolder[],
    onOk: () => void,
    onCancel: () => void
}

const MissingPdfs = (props: IProps) => {
    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Missing PDFs</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>The following voucher holders are missing PDFs and will not be printed.</div>
                <ul>
                    {props.list.map(value =>
                        <li>
                            {value.fullName + ' ' + value.registrationDate}
                        </li>
                    )}
                </ul>
            </Modal.Body>
            <Modal.Footer >
                <Button bsStyle='primary' onClick={props.onOk}>Ok</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default MissingPdfs;